export const TOGGLE_DEVICE = 'TOGGLE_DEVICE'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const EXPAND_MENU = 'EXPAND_MENU'

export const SWITCH_EFFECT = 'SWITCH_EFFECT'

export const SET_TOKEN = 'SET_TOKEN'

export const TOGGLE_NO_MENU = 'TOGGLE_NO_MENU'

export const LOGIN_USER = 'LOGIN_USER'
export const IS_AUDIT_DETAIL = 'IS_AUDIT_DETAIL'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js